/*!
 * Copyright © 2026 Nail Alliance - North America, Inc.
 * Authors: See snippets/copyright-notices.liquid in the theme.
 * No other use is authorized without a written contract.
 */

(() => {
  class SiteFooter extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.groups = [...this.querySelectorAll('[data-footer-details]')];
      this.handleToggle = this.handleToggle.bind(this);

      this.groups.forEach((group) => group.addEventListener('toggle', this.handleToggle));

      const success = this.querySelector('[data-newsletter-success]');
      if (success && window.location.hash === `#${this.querySelector('form')?.id}`) {
        success.focus({ preventScroll: true });
      }
    }

    disconnectedCallback() {
      this.groups?.forEach((group) => group.removeEventListener('toggle', this.handleToggle));
      this.initialized = false;
    }

    handleToggle(event) {
      const activeGroup = event.currentTarget;
      if (!activeGroup.open) return;

      this.groups.forEach((group) => {
        if (group !== activeGroup) group.open = false;
      });
    }
  }

  if (!customElements.get('site-footer')) {
    customElements.define('site-footer', SiteFooter);
  }
})();
